import { Component, Inject, OnInit } from '@angular/core';
import {
  MatBottomSheet,
  MatBottomSheetRef,
  MAT_BOTTOM_SHEET_DATA,
} from '@angular/material/bottom-sheet';
import {
  createshoppingListItem,
  kitchenSearchItem,
} from 'src/app/core/model/api-response/cooking-story-model';
import { CookingStoryShoppinglistDateService } from 'src/app/data/repository/cooking-story/cooking-story-shoppinglist-date.service';
import { KitchenRemoveConfirmComponent } from '../../kitchen-remove-confirm/kitchen-remove-confirm.component';

@Component({
  selector: 'app-kitchen-quick-bottomsheet',
  templateUrl: './kitchen-quick-bottomsheet.component.html',
  styleUrls: ['./kitchen-quick-bottomsheet.component.scss'],
})
export class KitchenQuickBottomsheetComponent implements OnInit {
  SWIPE_ACTION = { UP: 'swipeup', DOWN: 'swipedown' };
  ListItemText = null;
  active: boolean = false;
  activeId: string;
  item: kitchenSearchItem;
  type: 'edit' | 'search';

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public data: { item: kitchenSearchItem; id: string; text: string },
    private bottomSheetRef: MatBottomSheetRef<KitchenQuickBottomsheetComponent>,
    private cookingStoryShoppinglistDateService: CookingStoryShoppinglistDateService,
    private matBottomSheet: MatBottomSheet
  ) {}

  ngOnInit(): void {
    this.type = this.cookingStoryShoppinglistDateService.type;

    if (!this.data) {
      this.activeId = this.cookingStoryShoppinglistDateService.getActiveItem();
    } else {
      this.activeId = this.data.id;
    }
    this.cookingStoryShoppinglistDateService.changeActiveItem(this.activeId);
    if (this.cookingStoryShoppinglistDateService.getActiveItem()) {
      this.replaceData();
    }
    if (this.data?.text) {
      this.ListItemText = this.data.text;
    }
    this.checkActive();
  }
  swipe(action: string = this.SWIPE_ACTION.DOWN) {
    if (action === this.SWIPE_ACTION.DOWN) {
      this.bottomSheetRef.dismiss();
    }
  }
  checkActive() {
    if (this.ListItemText && this.ListItemText.length > 0) {
      this.active = true;
    } else {
      this.active = false;
    }
  }
  replaceData() {
    this.item = this.cookingStoryShoppinglistDateService.getItem(this.activeId);

    this.ListItemText = this.item?.quickAdd ? this.item.quickAdd : null;
  }
  chekedInput(data) {
    if (this.ListItemText && this.ListItemText.length > 0) {
      this.active = true;
    } else {
      this.active = false;
    }
  }
  goBack() {
    this.bottomSheetRef.dismiss();
  }
  save() {
    if (this.active) {
      const data = new createshoppingListItem(
        null,
        null,
        null,
        null,
        null,
        this.ListItemText
      );
      delete data.unit;
      delete data.amount;
      delete data.food;

      this.cookingStoryShoppinglistDateService.saveQuickAdd([data]);
      this.bottomSheetRef.dismiss();
    }
  }
  update() {
    if (this.active) {
      const data = new kitchenSearchItem(
        null,
        this.ListItemText,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        true,
        this.activeId
      );
      delete data.unit;
      delete data.amount;
      delete data.food;
      this.cookingStoryShoppinglistDateService.updateSave(this.activeId, data);
      this.bottomSheetRef.dismiss();
    }
  }
  delete() {
    // this.cookingStoryShoppinglistDateService.deleteItemList([this.activeId]);
    this.matBottomSheet.open(KitchenRemoveConfirmComponent, {
      panelClass: 'custom-bottomsheet-container',
      data: {
        id: this.activeId,
        type: 'shoppingList',
        foodname: this.ListItemText,
      },
    });
    this.bottomSheetRef.dismiss();
  }
}
